import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M328 180C302.3 180 272.1 196.9 268.1 222.1 266.4 233.3 279.6 240.4 288 233L297.5 224.5C312.3 211.3 343.7 211.3 358.5 224.5L368 233C376.5 240.4 389.6 233.2 387.9 222.1 383.9 196.9 353.7 180 328 180zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM353.6 304.6C327.6 312.9 289.1 317.7 248 317.7S168.4 312.9 142.4 304.6C132.5 301.5 123 310 124.7 320 132.7 367.1 196.1 400 248 400S363.3 367.1 371.3 320C372.9 310.1 363.6 301.5 353.6 304.6zM248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-wink.js
// module id = n0S+
// module chunks = 144